<template>
  <el-row
    class="date-row">
    <el-row class="fisrt-row">
      <el-col
        :xs="2"
        :sm="2"
        :md="2"
        :lg="2"
        :xl="2"
        class="col-calendar">
        <div class="calendar">
          <div class="month">
            {{ month | uppercase }}
          </div>
          <div class="day">
            {{ day }}
          </div>
        </div>
      </el-col>
      <!--///-->
      <el-row class="row-ticket">
        <el-col
          :span="24"
          class="date-event">
          {{ dateEventRow }}
        </el-col>
        <el-col
          :span="24"
          class="name-event">
          {{ nameEvent }}
        </el-col>
        <el-col
          :span="24"
          class="place-event">
          {{ venueEvent }}
        </el-col>
      </el-row>
    </el-row>
    <slot/>
    <!--<el-row
      v-for="(schedules, index) in hourEvent"
      :key="index"
      class="second-row">
      <el-col
        :xs="2"
        :sm="2"
        :md="2"
        :lg="2"
        :xl="2"
        class="hour-event">
        <span>{{ schedules }}hrs</span>
      </el-col>
      <el-col
        :xs="17"
        :sm="15"
        :md="15"
        :lg="15"
        :xl="15"
        class="available-tickets">
        <div class="available-content">
          <span>+1000&nbsp;</span>
          <span class="second-span hidden-xs-only">boletos</span>
          <i class="icon-special-icon"/>
        </div>
      </el-col>
      <el-col
        :xs="5"
        :sm="7"
        :md="7"
        :lg="7"
        :xl="7"
        class="buy-tickets">
        <el-button @click="goToZone(schedules)">Comprar</el-button>
        {{ schedules }}
      </el-col>
    </el-row>-->
  </el-row>
</template>

<script>
import moment from 'moment'
export default {
  name: 'MtDateRow',
  props: {
    nameEvent: {
      type: String,
      default: ''
    },
    venueEvent: {
      type: String,
      default: ''/* Array,
      default: function () {
        return {}
      } */
    },
    dateEvent: {
      type: String,
      default: ''
    },
    hourEvent: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    dateEventRow () {
      return moment(this.dateEvent).format('dddd, DD [de] MMMM YYYY')
    },
    month () {
      return moment(this.dateEvent).format('MMMM').slice(0, 3)
    },
    day () {
      return moment(this.dateEvent).format('DD')
    },
    hour () {
      return moment(this.dateEvent).format('LT')
    }
  },

  methods: {
    goToZone (id) {
      let zoneObject = {venue: this.venueEvent, date: this.dateEvent, hour: id}
      // this.$store.dispatch('setData', zoneObject)
      this.$router.push({name: 'Zonas', params: zoneObject})
      console.log(zoneObject)
    }
  }

}

</script>

<style lang="scss" scoped>

  .row-ticket {
    width: 100%;
  }
  .date-row{
    margin-bottom: 15px;
    background-color: white;
    padding: 30px;
    border-radius: 2px;
    position: relative;
    transition: all .3s ease-in-out;
    @media #{$Note} {
      padding: 20px;
    }
    .fisrt-row {
      display: flex;
      margin-bottom: 15px;
      @media #{$Elementxs} {
        border-bottom: 1px solid #E3E6EA;
        padding-bottom: 20px;
      }
    }
    .second-row{
      width: 100%;
      height: 40px;
      &:not(:last-child){
        margin-bottom: 20px;
      }
    }
  }
  .col-calendar {
    max-width: 60px;
    min-width: 60px;
  }
.calendar{
  background-color: #2894FF;
  border-radius: 2px;
  height: 40px;
  width: 40px;
  margin-right: 17px;
  text-align: center;
  position: relative;
  padding: 1px;
  .month{
    color: white;
    border-radius: 2px 2px 0 0;
    @include font-primary(8px, regular);
  }
  .day{
    background-color: white;
    @include font-primary(18px, regular);
    color: #2894FF;
    line-height: 25px;
    height: 27px;
    border-radius: 0 0 2px 2px;
  }
}
  @media only screen and (max-width: 1191px) {
    .calendar{
      min-width: 40px;
    }
    .hidden-available{
      .el-tag {
        padding: 0 5px;
      }
    }
  }

  .date-event {
    text-transform: uppercase;
    color: $carbon;
    @include font-primary(12px, semibold);
    margin-bottom: 10px;
    @media #{$Note} {
      margin-bottom: 5px;
    }
  }
  .name-event {
    color: $carbon;
    @include font-primary(10px, semibold);
    margin-bottom: 10px;
    @media #{$Note} {
      margin-bottom: 5px;
    }
  }
  .hour-event {
    span{
      line-height: 40px;
      color: $carbon;
      @include font-primary(13px, regular);
    }
  }
  .place-event {
    color: $dove;
    @include font-primary(12px, regular)
  }
  .available-tickets {
    height: 40px;
    .available-content {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .second-span{
        margin-right: 23px;
      }
      span {
        @include font-primary(12px, semibold);
        color: #2894FF;
        @media #{$Elementxs} {
          margin-right: 23px;
        }
      }
      i {
        color: #2894FF;
        margin-right: 22px;
        font-size: 15px;
        @media #{$Elementxs} {
          margin-right: 19px;
        }
      }
    }
  }
  .buy-tickets {
    @media #{$Elementxs} {
      padding-right: 10px;
    }
    @media #{$Note} {
      padding-right: 0;
    }
    button {
      background-color: $roseHeader;
      width: 100%;
      height: 40px;
      padding: 0;
      border: none;
      color: #F9D9DE;
      @include font-primary(14px, bold);
      @media #{$Elementxs} {
        background-color: transparent;
        color: $roseHeader;
        width: 100%;
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/mt-date-row.vue